import React, { useEffect, useState } from 'react';
import { getAllLogosByUser } from '../../services/Logo_service';
import { getUserDetails, } from '../../services/User_service';
import ModifierAnnonceService from '../../services/modificationAnnonce_service';

import { Annonce } from '../../models/AnnonceModel';
import ButtonCustom from '../../utils/custom-button';

interface AnnonceProps {
  annonceNow: Annonce;
  entete: string;
  floid: string;
  updateEntete: (newTxt: string) => void;
  updateFloid: (newTxt: string) => void;
  closeModal: () => void;
  updateTextAnnonce: (newText: string) => void;
}

interface Logo {
  id: number;
  libelle: string;
  user_id?: number;
  floId?: string;
}

const SaisirAdditif: React.FC<AnnonceProps> = ({
  annonceNow,
  entete,
  updateEntete,
  updateFloid,
  floid,
}) => {
  const [textAnnonce, setTextAnnonce] = useState(annonceNow.textAnnonce || '');

  // const [textAnnonce, setTextAnnonce] = useState('');

  const [choix, setChoix] = useState('');
  const [selectedLogos, setSelectedLogos] = useState<number[]>([]);
  const [typeChoice, setTypeChoice] = useState('');
  const [currentAnnonce, setCurrentAnnonce] = useState<Annonce | null>(null);
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const [modalType, setModalType] = useState<'detail' | 'additif' | null>(null);

  const [errors, setErrors] = useState<{ denomination?: string; texteAnnonce?: string; entete?: string; annonceur?: string; reference?: string }>({});
  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setChoix(event.target.value);
  };

  const handleTextAnnonceChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setTextAnnonce(event.target.value);
  };

  const handleCloseModal = () => {
    setModalIsOpen(false);
    setCurrentAnnonce(null);
    setModalType(null);
  };

  const handleSaveClick = async () => {
    try {
      const response = await ModifierAnnonceService(annonceNow.id.toString(), {
        ...annonceNow,
        textAnnonce,
      }, null);
      if (response && response.textAnnonce) {
        setCurrentAnnonce({
          ...annonceNow,
          textAnnonce: response.textAnnonce, // Mettre à jour l'état local avec les nouvelles données
        });
      }
      alert('Texte enregistré avec succès !');
      // console.log('Réponse:', response);
    } catch (error) {
      console.error('Erreur lors de la sauvegarde des modifications:', error);
      alert('Une erreur est survenue lors de la sauvegarde.');
    }
  };

  const updateTextAnnonce = (newText: string) => {
    setTextAnnonce(newText);
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { id, value } = event.target;
    if (id === 'entete') updateEntete(value);
  };


  useEffect(() => {
    const fetchLogos = async () => {
      try {
        const fetchedLogos = await getAllLogosByUser();
        setLogos(fetchedLogos);
        localStorage.setItem('logos', JSON.stringify(fetchedLogos));
      } catch (error) {
        console.error('Erreur lors de la récupération des logos:', error);
      }
    };

    const storedLogos = localStorage.getItem('logos');
    if (storedLogos) {
      setLogos(JSON.parse(storedLogos));
    } else {
      fetchLogos();
    }
  }, []);

  const handleCheckboxChange = (logoId: number) => {
    setSelectedLogos((prevSelected) => {
      if (prevSelected.includes(logoId)) {
        return prevSelected.filter(id => id !== logoId);
      } else {
        const selectedLogo = logos.find(logo => logo.id === logoId);
        if (selectedLogo) {
          // Use libelle (file name / path) as floid so that support-presse can build the correct image src
          if (selectedLogo.libelle) {
            updateFloid(selectedLogo.libelle);
          }
        }
        return [...prevSelected, logoId];
      }
    });
  };


  const [fullscreenImage, setFullscreenImage] = useState<string | null>(null);


  const openFullscreen = (image: string) => {
    setFullscreenImage(image);
  };
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchUserData = async () => {
      setLoading(true);
      const userData = await getUserDetails();
      if (userData) {
        setUser({
          name: userData.name || '',
          firstname: userData.firstname || '',
          email: userData.email || '',
          reference: userData.reference || '',
          civility: userData.civility || '',
          code_parrainage: userData.code_parrainage || '',
          adresse: userData.adresse || '',
          number: userData.number || '',
          country: userData.country || '',
          postal_code: userData.postal_code || '',
          dateCreation: userData.createdAt ? new Date(userData.createdAt).toLocaleDateString() : '',
          raison_social: userData.raison_social || '',
          code_SIREN: userData.code_SIREN || '',
          code_NAF: userData.code_NAF || '',
          tv_intra: userData.tv_intra || ''
        });
      }
      setLoading(false);
    };

    fetchUserData();
  }, []);

  const handleTextChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setTextAnnonce(event.target.value);
  };

  const API_URL = process.env.REACT_APP_API_BASE;
  const [logos, setLogos] = useState<Logo[]>([]);

  const [user, setUser] = useState({
    name: '',
    firstname: '',
    email: '',
    reference: '',
    civility: '',
    code_parrainage: '',
    adresse: '',
    number: '',
    country: '',
    postal_code: '',
    dateCreation: '',
    raison_social: '',
    code_SIREN: '',
    code_NAF: '',
    tv_intra: ''
  });

  return (
    <div className="container mt-2">
      <div>
        <h6 className="border-bottom pb-2 bg-orange">EN-TETE DU CABINET</h6>
        <p>
          Vous pouvez paramétrer l'entité de votre cabinet ou étude sur la <span className="bleu">gestion de votre compte</span>
        </p>
        <div className="mb-3 row">
          <label htmlFor="choix" className="col-sm-3 col-form-label">Choisir</label>
          <div className="col-sm-9">
            <select
              className="form-select"
              id="choix"
              name="choix"
              onChange={handleSelectChange}
              value={choix}
            >
              <option value="option1">Pas en-tête</option>
              <option value="option2">En-tête sans logo</option>
              <option value="option3">En-tête avec logo</option>
              <option value="option4">Logo uniquement</option>
            </select>
          </div>
        </div>

        {choix === 'option2' && (
          <div className="mb-3 row">
            <label htmlFor="choix" className="col-sm-3 col-form-label">En-tête du cabinet</label>
            <div className="col-sm-9">
              <textarea
                className="form-control w-100 custom-textarea"
                id="entete"
                rows={3}
                value={entete}
                onChange={(e) => updateEntete(`${user.raison_social || ''} ${user.adresse || ''} ${user.postal_code || ''} ${user.country || ''}`)}
                placeholder={`${user.raison_social || ''}\n${user.adresse || ''}\n${user.postal_code || ''} ${user.country || ''}`}
                style={{ color: 'black' }}
              ></textarea>
            </div>
          </div>
        )}

        {choix === 'option3' && <div className="bg-light p-3 ">
          <div>
            <label htmlFor="choix" className="col-sm-3 col-form-label">En-tête du cabinet</label>
            <div className="col-sm-9">
              <textarea
                className="form-control w-100 custom-textarea"
                id="entete"
                rows={3}
                value={entete}
                onChange={(e) => updateEntete(`${user.raison_social || ''} ${user.adresse || ''} ${user.postal_code || ''} ${user.country || ''}`)}
                placeholder={`${user.raison_social || ''}\n${user.adresse || ''}\n${user.postal_code || ''} ${user.country || ''}`}
                style={{ color: 'black' }}
              ></textarea>
            </div>
          </div>
          <div className='ok mt-3'>
            {logos.map((logo) => (
              <div key={logo.id} className="col-md-3 mb-1">
                <label>
                  <input
                    type="checkbox"
                    value={floid}
                    checked={selectedLogos.includes(logo.id)}
                    onChange={() => handleCheckboxChange(logo.id)}
                  />
                  <img
                    src={`${API_URL}/${logo.libelle}`}
                    alt={`Logo ${logo.id}`}
                    id="card-img-top"
                    onClick={() => openFullscreen(logo.libelle)}
                    style={{ cursor: 'pointer' }}
                  />
                </label>
              </div>
            ))}
          </div>
        </div>}

        {choix === 'option4' && <div className="bg-light p-3 ok">
          {logos.map((logo) => (
            <div key={logo.id} className="col-md-3 mb-1">
              <label>
                <input
                  type="checkbox"
                  checked={selectedLogos.includes(logo.id)}
                  onChange={() => handleCheckboxChange(logo.id)}
                />
                <img
                  src={`${API_URL}/${logo.libelle}`}
                  alt={`Logo ${logo.id}`}
                  id="card-img-top"
                  onClick={() => openFullscreen(logo.libelle)}
                  style={{ cursor: 'pointer' }}
                />
              </label>
            </div>
          ))}
        </div>}

        <h6 className="border-bottom pb-2 bg-orange">RAISON SOCIALE</h6>
        <p>
          Indiquer la raison sociale de la société ou la dénomination du Cabinet de Notaire annonceur ou l'état civil
          de la personne concernée par l'annonce. En option, vous pouvez ajouter une référence client.
        </p>
        <div className="mb-3 row">
          <label htmlFor="denomination" className="col-sm-3 col-form-label">Dénomination</label>
          <div className="col-sm-9">
            <input
              className={`form-control ${errors.denomination ? 'is-invalid' : ''}`}
              type="text"
              id="denomination"
              value={annonceNow.denomination}
              onChange={handleInputChange}
            />
            {errors.denomination && (
              <small className="text-danger">{errors.denomination}</small>
            )}
          </div>
        </div>

        <h6 className="border-bottom pb-2">L'ANNONCE</h6>
        <div className="mb-3 row">
          <label htmlFor="txtAnnonce" className="col-sm-3 col-form-label">Texte de l'annonce</label>
          <div className="col-sm-9">
            <textarea
              className="form-control"
              id="txtAnnonce"
              rows={3}
              value={textAnnonce}
              onChange={handleTextChange}
            >
            </textarea>
          </div>
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '20px' }}>
        <ButtonCustom title="Enregistrer" color="#F4A261" onClick={handleSaveClick} />
      </div>
    </div>
  );
};

export default SaisirAdditif;